import apiClient from "./apiClient";

/**
 * Fetch every blog post.
 * GET /api/blogs
 */
export const getAllBlogs = () => apiClient.get("/blogs");

/**
 * Fetch a single blog post by its id.
 * GET /api/blogs/:id
 */
export const getBlogById = (id) => apiClient.get(`/blogs/${id}`);

/**
 * Create a new blog post.
 * POST /api/blogs
 */
export const createBlog = (data) => apiClient.post("/blogs", data);

/**
 * Update an existing blog post.
 * PUT /api/blogs/:id
 */
export const updateBlog = (id, data) => apiClient.put(`/blogs/${id}`, data);

/**
 * Delete a blog post.
 * DELETE /api/blogs/:id
 */
export const deleteBlog = (id) => apiClient.delete(`/blogs/${id}`);
